import styled from 'styled-components';
import { Popup, PopupProps } from 'src/components/common/Popup';
import { useTranslate } from 'react-t7e';
import { QRCode } from 'src/components/common/QRCode';
import { useRouter } from 'next/router';

export interface EventPageTicketPopupProps extends PopupProps {
  ticket: string;
}

const StyledPopup = styled(Popup)`
  width: auto;
  height: auto;
`;

const Title = styled.h4`
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
`;

const StyledQRCode = styled(QRCode)`
  margin: 32px 0 24px;
`;

export const EventPageTicketPopup = ({
  ticket,
  ...props
}: EventPageTicketPopupProps) => {
  const { _ } = useTranslate();
  const router = useRouter();

  return (
    <StyledPopup
      variant="secondary"
      queryParam="ticket"
      enterDelay={router.query.ticket ? 300 : 0}
      {...props}
    >
      <Title>{_('Ticket')}</Title>
      <StyledQRCode value={ticket} />
    </StyledPopup>
  );
};
